var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.0686035C4.477 0.0686035 0 4.5456 0 10.0686C0 15.5916 4.477 20.0686 10 20.0686C15.523 20.0686 20 15.5916 20 10.0686H18C18 14.4866 14.418 18.0686 10 18.0686C5.582 18.0686 2 14.4866 2 10.0686C2 5.6506 5.582 2.0686 10 2.0686C12.75 2.0686 15.176 3.4556 16.615 5.5686H14V7.5686H20V1.5686H18V4.0686C16.176 1.6386 13.271 0.0686035 10 0.0686035Z",
    fill: "#0696A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadBlue);
export default __webpack_public_path__ + "static/media/reload-blue.7df55624650d75bbef2d42f9905675cc.svg";
export { ForwardRef as ReactComponent };